import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Constants } from '../../../model/common.model';
import { PanelModule } from '../../../modules/panel.module';

@Component({
  selector: 'brt-promotion-price',
  standalone: true,
  imports: [PanelModule],
  templateUrl: './promotion-price.component.html',
  styleUrl: './promotion-price.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PromotionPriceComponent),
      multi: true
    }
  ]
})
export class PromotionPriceComponent {
  constructor() { }
  discountTypes = Constants.DiscountTypes;

  value: any;
  hasPerTypePrices = false;

  changed() { this.onChange(this.value); }
  writeValue(value: any) {
    this.value = value;
    this.hasPerTypePrices = value != null &&
      (value.DeliveryValue != null || value.PickupValue != null || value.DineInValue != null);
  }

  togglePerTypePrices(enabled: boolean) {
    this.hasPerTypePrices = enabled;
    if (!enabled && this.value) {
      delete this.value.DeliveryValue;
      delete this.value.PickupValue;
      delete this.value.DineInValue;
      this.changed();
    }
  }
  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any) { this.onTouched = fn; }
  onChange = (_: any) => { };
  onTouched = () => { };

  reset() {
    this.value = null;
    this.hasPerTypePrices = false;
    this.changed();
  }
}
